import { StyledLanguage } from '@/components/styles'

export default function Language({ href, title, ...props }) {
  return (
    <StyledLanguage href={href} {...props}>
      {title}
    </StyledLanguage>
  )
}